import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getUserBuildingAction } from 'store/actions/userActions';
import { useStableKey } from './useStableKey';

/**
 * Fetches paginated buildings for a delegation/property scope.
 * Dependencies are primitive/stable keys only — safe for production lists.
 */
export function useBuildingListFetch({
  propertyId,
  filter,
  pagination,
  sortOptions,
  selectedBType = [],
  isSHouse = [],
  enabled = true,
  role,
}) {
  const dispatch = useDispatch();
  const propertyKey = useStableKey(propertyId);
  const sortKey = useStableKey(sortOptions);
  const selectedBTypeKey = useStableKey(selectedBType);
  const isSHouseKey = useStableKey(isSHouse);

  useEffect(() => {
    // Allow explicit empty arrays (no delegated properties) so the UI fetches an
    // empty page instead of skipping and leaving stale / unscoped results.
    if (!enabled || propertyId == null) return;
    if (!Array.isArray(propertyId) && (!propertyKey || propertyKey === 'null')) return;

    dispatch(
      getUserBuildingAction({
        id: propertyId,
        ...(role ? { role } : {}),
        filter,
        offset: pagination.pageNumber * pagination.rowsPerPage,
        limit: pagination.rowsPerPage,
        sortOptions,
        selectedBType,
        isSHouse,
      }),
    );
  }, [
    enabled,
    propertyKey,
    propertyId,
    role,
    dispatch,
    filter.searchText,
    pagination.pageNumber,
    pagination.rowsPerPage,
    sortKey,
    selectedBTypeKey,
    isSHouseKey,
  ]);
}
